import React, { useState, Fragment, useEffect, useRef, useImperativeHandle } from 'react';
import {
  Button as MButton,
  Typography,
  Select,
  MenuItem,
  Icon,
  TextField,
  FormControl,
  InputLabel,
  FormHelperText,
  Chip,
  RadioGroup,
  Radio,
  FormControlLabel,
  Checkbox,
  FormGroup,
  InputAdornment,
  IconButton,
  Tooltip,
  Toolbar,
  Box,
  ButtonGroup,
} from '@material-ui/core';
import { get, set, map, find, size, noop, flatten, isObject, last } from 'global/lib/lodash';
import clsx from 'clsx';
import { Access } from 'global/components/droprealms';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { DropzoneArea } from 'global/components/Dropzone';
import { isValidHex, _size, ensureArray, customSearch } from '../../utils';
import { ChromePicker } from 'react-color';
import { LoadingTools } from '../LoadingIcons';
import RichText from 'mui-rte';
import { draftToHtml, htmlToDraft } from '../../utils/htmlconv';
import DropArea from 'global/components/drop-area';
import Image, { ImageList } from 'global/components/image';
import { useStyles, Symbols } from './styles';
import { ColorSlider } from '../color-slider';
import { EditorState, Modifier } from 'draft-js';
import { ImageSelectBtn } from 'feature/report/AssessmentScore/SystemScore';
import { Button } from 'global/components/Button';
import { Column } from '../row';
import DragSortableList from 'global/components/sortable-list';
import { debounce } from '../../lib/lodash';
import { TradeSelect } from '../trade-select';
import { AutoComplete } from '../Autocomplete';

const modify = (editorState, { content }) => {
  const selection = editorState.getSelection();
  const contentState = editorState.getCurrentContent();
  let nextEditorState = EditorState.createEmpty();

  const nextContentState = Modifier.insertText(contentState, selection, content);
  nextEditorState = EditorState.push(editorState, nextContentState, 'insert-characters');

  return nextEditorState;
};

export const convertJBuilderToObj = (d) => {
  const json = {};

  d.map((k) => {
    const { property, value, id } = k;
    set(json, [property], value);
    if (id) {
      set(json, 'id', id);
    }
  });

  return json;
};

export const convertObjToJbuilder = (obj) => {
  obj = obj || {};

  const values = [];

  Object.keys(obj).map((k) => {
    values.push({ property: k, value: obj[k] });
  });

  return values;
};

const symbols = [
  {
    name: 'cust-degree',
    content: '°',
    icon: <div style={Symbols.icon}>°</div>,
    type: 'callback',
    onClick: function (editorState, name, anchor) {
      return modify(editorState, this);
    },
  },
  {
    name: 'cust-tm',
    content: '™',
    icon: <div style={Symbols.icon}>™</div>,
    type: 'callback',
    onClick: function (editorState, name, anchor) {
      return modify(editorState, this);
    },
  },
  {
    name: 'cust-copy',
    content: '©',
    icon: <div style={Symbols.icon}>©</div>,
    type: 'callback',
    onClick: function (editorState, name, anchor) {
      return modify(editorState, this);
    },
  },
  {
    name: 'cust-rtm',
    content: '®',
    icon: <div style={Symbols.icon}>®</div>,
    type: 'callback',
    onClick: function (editorState, name, anchor) {
      return modify(editorState, this);
    },
  },
];

export default React.forwardRef((props, ref) => {
  const { showPosition, onSubmit, onFormState, loading, useStaticScreens } = props;
  const [formState, setFormState] = useState({});
  const [subState, setSubState] = useState({});
  const [screenIndex, setScreenIndex] = useState(0);
  const [_screens, setScreens] = useState(props.screens);
  const [collapsed, setCollapsed] = useState({});
  const formref = useRef();

  useEffect(() => {
    const collap = {};
    props.screens.forEach((s, i) => {
      if (Array.isArray(s)) {
        s.forEach((scr, _i) => {
          set(collap, `${i}.${_i}`, get(scr, 'collapsable.collapsed', false));
        });
      } else {
        set(collap, i, get(s, 'collapsable.collapsed', false));
      }
    });
    setCollapsed(collap);
  }, []);

  const useHeight = get(props, 'useHeight', true);
  const classes = useStyles({ useHeight, showPosition });

  const screens = useStaticScreens ? _screens : get(props, 'screens', []);

  useEffect(() => {
    if (!props.updateStaticScreens) {
      return;
    }

    const buildInput = (input, i) => {
      if (Array.isArray(input)) {
        return input.map((inp, _i) => buildInput(inp, `${i}.${_i}`));
      }
      const propScreenInputs = get(props, `screens.${i}.inputs`, []) || [];
      const newprops = get(
        propScreenInputs.find((si) => get(si, 'id', '').includes(input.id)),
        'props',
        input.props
      );

      return {
        ...input,
        props: newprops || {},
      };
    };

    const newscreens = [...screens].map((screen, i) => {
      return {
        ...screen,
        inputs: (screen.inputs || []).map((s) => buildInput(s, i)),
      };
    });

    setScreens(newscreens);
  }, props.updateStaticScreens || []);

  const showAllScreens = get(props, 'showAllScreens', false);
  const showNavigation = showAllScreens ? false : get(props, 'showNavigation', true);
  const canSubmit = showAllScreens && get(props, 'canSubmit', false);
  const isNoMarginContainer = get(props, 'isNoMarginContainer', false);

  const updateFS = debounce((fs) => {
    onFormState && onFormState(fs);
  }, 1);

  const updateState = (id, val, update = true, notify = true) => {
    set(formState, id, val);
    if (update) {
      setFormState({ ...formState });
    }
    set(ref, 'current.formState', formState);
    if (notify) {
      updateFS(formState);
    }
  };

  const clearState = () => {
    Object.keys(formState).forEach((k) => {
      set(formState, k, undefined);
    });
    setFormState({});
    onFormState && onFormState(formState);
  };

  const addAnotherInput = (input, index) => {
    if (input.onAdd) {
      return input.onAdd();
    }

    const _screens = [...screens];
    const currentInputs = get(_screens, [screenIndex, 'inputs'], []);
    const newIndex = index + 1;

    //insert new input
    currentInputs.splice(newIndex, 0, {
      ...input,
      id: `${input.id}|${newIndex}`,
    });

    //delete items from input that should only be on the last one, which is what we inserted
    set(currentInputs, [index, 'add'], undefined);
    set(_screens, [screenIndex, 'inputs'], currentInputs);
    setScreens(_screens);
  };

  const removeInput = (input, index) => {
    if (input.onRemove) {
      return input.onRemove();
    }

    const _screens = [...screens];
    const currentInputs = get(_screens, [screenIndex, 'inputs'], []);
    const itemToRemove = currentInputs[index];

    //insert new input
    currentInputs.splice(index, 1);
    delete formState[get(itemToRemove, 'id')];

    //delete items from input that should only be on the last one, which is what we inserted
    set(currentInputs, [index - 1, 'add'], get(itemToRemove, 'add'));
    set(_screens, [screenIndex, 'inputs'], currentInputs);
    setScreens(_screens);
  };

  const getInputType = (screen, input, index, sIndex) => {
    if (Array.isArray(input)) {
      return <div className={classes.row}>{input.map((inp, i) => getInputType(screen, inp, i, sIndex))}</div>;
    }

    // if (input.useSource || screen.useSource) {
    //   input = get(props, `screens.${sIndex}.inputs.${index}`, input);
    // }

    const isType = get(input, 'type');
    let value = get(formState, input.id);
    if (value === undefined) {
      if (input.defaultValue && typeof input.defaultValue === 'function') {
        const val = input.defaultValue(formState);
        //this should prevent this from hitting an endless loop if the defaultValue
        //function happens to return undefined
        value = val === undefined ? null : val;
        updateState(input.id, value);
      }
    }

    const { helperText, ...inputProps } = get(input, 'props', {});
    const helperTextType = helperText ? (typeof helperText === 'function' ? helperText(formState) : helperText) : undefined;

    let comp = null;

    const isDisabled = get(inputProps, 'disabled', false);
    const variant = isDisabled ? undefined : 'outlined';
    const isLast = index === screen.inputs.length - 1;
    const center = get(input, 'center', false);

    if (isType) {
      if (isType === 'RealmDialog') {
        const continueOnSelect = get(inputProps, 'continueOnSelect', true);
        comp = (
          <div style={{ width: '100%', height: '100%' }}>
            <Access
              key={index}
              onSelectedChange={(sel) => {
                updateState(input.id, sel);
                if (inputProps.singleSelect && continueOnSelect) {
                  setScreenIndex(screenIndex + 1);
                }
              }}
              {...inputProps}
            />
          </div>
        );
      } else if (isType === 'Select') {
        const data = typeof input.data === 'function' ? input.data() : input.data;
        comp = (
          <FormControl variant={variant} className={classes.formControl}>
            {inputProps.label && <InputLabel>{inputProps.label}</InputLabel>}
            <Select
              classes={{
                root: classes.width100,
              }}
              disableUnderline
              value={value || ''}
              onChange={(e) => updateState(input.id, e.target.value)}
              {...inputProps}
            >
              {map(data, (item, i) => {
                const d = input.item ? input.item(item) : item;
                return (
                  <MenuItem key={i} value={get(d, 'value', i)}>
                    {get(d, 'title', '')}
                  </MenuItem>
                );
              })}
              {size(data) === 0 && <MenuItem>No Options</MenuItem>}
            </Select>
            {helperTextType && <FormHelperText>{helperTextType}</FormHelperText>}
          </FormControl>
        );
      } else if (isType === 'MultiSelect') {
        const data = typeof input.data === 'function' ? input.data() : input.data;

        const isDisabledData = isDisabled ? [''] : [];

        comp = (
          <FormControl variant="filled" className={classes.formControl}>
            {inputProps.label && (
              <InputLabel
                classes={{
                  root: classes.formInputLabel,
                  shrink: classes.formLabelShrink,
                }}
              >
                {inputProps.label}
              </InputLabel>
            )}
            <div className={classes.formWrap}>
              <Select
                className={classes.width100}
                classes={{
                  root: classes.width100,
                }}
                multiple
                disableUnderline
                value={size(value) ? value : isDisabledData}
                onChange={(e) => {
                  const val = e.target.value.filter((f) => f);
                  if (size(val)) {
                    updateState(input.id, val);
                  }
                }}
                {...inputProps}
              >
                {map(size(data) ? data : isDisabledData, (item, i) => {
                  const d = input.item ? input.item(item) : item;
                  return (
                    <MenuItem key={i} value={get(d, 'value', i)}>
                      {get(d, 'title', '')}
                    </MenuItem>
                  );
                })}
                {size(data) === 0 && <MenuItem>No Options</MenuItem>}
              </Select>
              {value && (
                <div className={classes.multiSelectChipContainer}>
                  {value.map((sel, i) => {
                    const selected = find(data, (item) => {
                      const dd = input.item ? input.item(item) : item;
                      return dd.value === sel ? dd : false;
                    });
                    if (!selected) {
                      //item doens't exist in array so update formstate
                      value.splice(i, 1);
                      updateState(input.id, value);
                    }
                    const item = selected ? input.item(selected) : null;
                    return (
                      <div key={i} className={classes.multiSelectChipWrap}>
                        <Chip
                          key={sel}
                          size={'small'}
                          label={get(item, 'title', '')}
                          className={classes.multiSelectChip}
                          onDelete={
                            isDisabled
                              ? undefined
                              : () => {
                                  value.splice(i, 1);
                                  updateState(input.id, value);
                                }
                          }
                          {...get(input, 'chipProps', {})}
                        />
                        {input.chipTextAdd && <Typography variant={'caption'}>{input.chipTextAdd}</Typography>}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            {helperTextType && <FormHelperText>{helperTextType}</FormHelperText>}
          </FormControl>
        );
      } else if (isType === 'UserSelect') {
        const liveData = get(get(props, 'screens', []), [sIndex, 'inputs', index, 'data']);
        const inpData = liveData || input.data;
        const data = typeof inpData === 'function' ? inpData() : inpData;

        const sectoredUsers = (data || [])
          .filter((d) => !!get(d, 'contentRealm.closestRealm'))
          .reduce((a, item) => set(a, get(item, 'contentRealm.distance'), [...get(a, get(item, 'contentRealm.distance', []), []), item]), {});

        const sortedData = Object.keys(sectoredUsers).map((k) =>
          sectoredUsers[k]
            .sort((a, b) => {
              return get(a, 'name', '').localeCompare(get(b, 'name', ''));
            })
            .map((opt) => {
              return {
                ...opt,
                groupBy: `${get(opt, 'contentRealm.closestRealm')}${get(opt, 'contentRealm.belongsToUserRealm') === 0 ? ' - Other Companies' : ''}`,
              };
            })
            .sort((a, b) => {
              return get(a, 'groupBy', '').localeCompare(get(b, 'groupBy', ''));
            })
        );

        comp = (
          <FormControl variant="standard" className={classes.formControl}>
            <div className={!inputProps.disabled && classes.formWrap}>
              <AutoComplete
                classes={
                  inputProps.disabled
                    ? {
                        groupLabel: classes.primaryColor,
                        tag: classes.userSelectChip,
                        endAdornment: classes.collapsedScreen,
                      }
                    : {
                        groupLabel: classes.primaryColor,
                      }
                }
                variant="standard"
                multiple={get(inputProps, 'multiple', true)}
                options={flatten(sortedData)}
                groupBy={(opt) => opt.groupBy}
                getOptionLabel={(d) => {
                  const name = get(d, 'name', '');
                  if (isDisabled) {
                    const optIndex = ensureArray(value || []).findIndex((f) => f.id === get(d, 'id'));
                    const isLast = optIndex === size(ensureArray(value || [])) - 1;
                    return isLast ? name : `${name},`;
                  }
                  return name;
                }}
                disableCloseOnSelect={true}
                onChange={(e, vals) => {
                  updateState(input.id, vals);
                }}
                value={value || []}
                renderInput={(params) => <TextField variant="standard" {...inputProps} onChange={noop} helperText={helperTextType} {...params} />}
                {...inputProps}
              />
            </div>
          </FormControl>
        );
      } else if (isType === 'TradeSelect') {
        comp = (
          <div>
            {inputProps.label && (
              <div>
                <InputLabel
                  classes={{
                    root: classes.formLabelShrink,
                    shrink: classes.formLabelShrink,
                  }}
                  style={{ backgroundColor: 'transparent' }}
                >
                  {inputProps.label}
                </InputLabel>
              </div>
            )}
            <TradeSelect {...inputProps} value={value || []} onChange={(v) => updateState(input.id, v)} />
            {helperTextType && <FormHelperText>{helperTextType}</FormHelperText>}
          </div>
        );
      } else if (isType === 'Autocomplete') {
        const liveData = get(get(props, 'screens', []), [sIndex, 'inputs', index, 'data']);
        const inpData = liveData || input.data;
        const data = typeof inpData === 'function' ? inpData() : inpData;
        // If the default value is a string that matches one of the data options, we set it to that option
        //   This reduces the complexity of setting a default value by allowing it to be passed as a string
        //   but is particularly valuable when setting the default from a previously entered string value (on form refresh)
        if (typeof value === 'string' || value instanceof String) {
          flatten(data).every((d) => {
            if (get(d, 'name') === value) {
              value = d;
              return false;
            }
            return true;
          });
        }

        if (inputProps.filterType === 'customsearch' && !inputProps.filterOptions) {
          set(inputProps, 'filterOptions', (opts, s) => customSearch(opts, s, {}, true));
        }

        const onBlur = () => {
          let sel = value;

          let isPotentiallyNew = typeof sel === 'string' || sel instanceof String;
          if (isPotentiallyNew) {
            sel = sel.trim();

            const hasMatch = flatten(data).find((r) => {
              return r.name.toLowerCase() == sel.toLowerCase();
            });

            if (hasMatch) {
              sel = hasMatch;
            }
          }

          updateState(input.id, sel);
        };

        comp = (
          <FormControl variant="standard" className={classes.formControl}>
            <div className={!inputProps.disabled && classes.formWrap}>
              <AutoComplete
                classes={
                  inputProps.disabled
                    ? {
                        groupLabel: classes.primaryColor,
                        tag: classes.userSelectChip,
                        endAdornment: classes.collapsedScreen,
                      }
                    : {
                        groupLabel: classes.primaryColor,
                      }
                }
                variant="standard"
                multiple={get(inputProps, 'multiple', false)}
                options={flatten(data)}
                getOptionLabel={(d) => {
                  const name = get(d, 'label', '') || get(d, 'name', '');
                  if (isDisabled) {
                    const vals = ensureArray(value || []);
                    const optIndex = vals.findIndex((f) => f.id === get(d, 'id'));
                    const isLast = size(vals) === 1 ? true : optIndex === size(value) - 1;
                    return isLast ? name : `${name},`;
                  }
                  return name;
                }}
                onChange={(e, vals) => {
                  updateState(input.id, vals);
                  inputProps.onSelectOption && inputProps.onSelectOption(vals);
                }}
                onInputChange={(e, val) => {
                  // if the newly typed string matches an option, set the option as the value
                  // This reduces unecessary new creation when a value is typed the same as one in the option list
                  if (typeof val === 'string' || val instanceof String) {
                    const valLower = val.toLowerCase();
                    if (
                      flatten(data).every((d) => {
                        if (get(d, 'name').toLowerCase() === valLower) {
                          updateState(input.id, d);
                          return false;
                        }
                        return true;
                      })
                    ) {
                      updateState(input.id, val);
                    }
                  } else {
                    updateState(input.id, val);
                  }
                }}
                freeSolo={true}
                includeInputInList={true}
                renderInput={(params) => <TextField variant="standard" {...inputProps} onBlur={noop} onChange={noop} helperText={helperTextType} {...params} />}
                defaultValue={value}
                onBlur={onBlur}
                {...inputProps}
              />
            </div>
          </FormControl>
        );
      } else if (isType === 'TextField') {
        comp = (
          <TextField
            variant={variant}
            onChange={(e) => updateState(input.id, e.target.value)}
            value={value}
            classes={{
              root: classes.itemRoot,
            }}
            {...inputProps}
          />
        );
      } else if (isType === 'RichText') {
        if (isDisabled) {
          comp = (
            <FormControl disabled={true} className={clsx(classes.itemRoot, classes.block, 'MuiTextField-root')}>
              {!!get(inputProps, 'label') && (
                <InputLabel className="MuiFormLabel-filled" shrink={true}>
                  {get(inputProps, 'label')}
                </InputLabel>
              )}
              <div
                style={{ width: '100%', display: 'block' }}
                className={'MuiInputBase-root MuiInput-root MuiInput-underline Mui-disabled Mui-disabled MuiInputBase-formControl MuiInput-formControl'}
                dangerouslySetInnerHTML={{ __html: value || '<p></p>' }}
              />
            </FormControl>
          );
        } else {
          //RICH TEXT DOES NOT AUTOUPDATE onFormState BECAUSE OF INFINITE LOOPING
          const upd = (e) => {
            const contentState = e.getCurrentContent();
            const html = draftToHtml(contentState);
            updateState(input.id, html, false, false);
          };
          comp = (
            <FormControl variant="filled" className={clsx(classes.formControl, classes.formWrapHover)}>
              <div className={clsx('MuiFormControl-root MuiTextField-root', classes.itemRoot)}>
                <div className="RichText">
                  <RichText
                    defaultValue={htmlToDraft(value)}
                    onChange={upd}
                    toolbarButtonSize="small"
                    controls={[
                      'title',
                      'bold',
                      'italic',
                      'underline',
                      'strikethrough',
                      'highlight',
                      'undo',
                      'redo',
                      'link',
                      'media',
                      'numberList',
                      'bulletList',
                      'quote',
                      'code',
                      'clear',
                      'save',
                      ...symbols.map((s) => s.name),
                    ]}
                    customControls={symbols}
                    {...inputProps}
                  />
                </div>
              </div>
            </FormControl>
          );
        }
      } else if (isType === 'KeyboardDatePicker') {
        comp = (
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              variant={variant}
              format="MM/dd/yyyy"
              autoOk={true}
              onChange={(e) => updateState(input.id, e)}
              classes={{
                root: classes.itemRoot,
              }}
              value={value || null}
              {...inputProps}
            />
          </MuiPickersUtilsProvider>
        );
      } else if (isType === 'ToggleButton') {
        comp = (
          <FormControl className={clsx(classes.toggleFormControl, center && classes.formControlCenter)}>
            {inputProps.label && <InputLabel className={clsx(classes.toggleLabel, center && classes.labelCenter)}>{inputProps.label}</InputLabel>}
            <ToggleButtonGroup
              classes={{
                root: classes.toggleBtnRoot,
              }}
              size="small"
              value={value}
              onChange={isDisabled ? undefined : (e, val) => val && updateState(input.id, val)}
              {...inputProps}
            >
              {input.options.map((opt, i) =>
                isDisabled ? (
                  opt.value === value ? (
                    <ToggleButton key={i} {...opt}>
                      {opt.title}
                    </ToggleButton>
                  ) : null
                ) : (
                  <ToggleButton key={i} {...opt}>
                    {opt.title}
                  </ToggleButton>
                )
              )}
            </ToggleButtonGroup>
            {helperTextType && <FormHelperText>{helperTextType}</FormHelperText>}
          </FormControl>
        );
      } else if (isType === 'DropZone') {
        comp = (
          <FormControl className={clsx(classes.formControl, 'dropZone')}>
            {inputProps.label && <InputLabel className={clsx(classes.formInputLabel, classes.formLabelShrink)}>{inputProps.label}</InputLabel>}
            {!isDisabled && <DropzoneArea onChange={(files) => updateState(input.id, files)} {...inputProps} showAlerts={['info', 'error']} />}
            {!!get(inputProps, 'initialFiles') && (
              <div className={clsx(classes.initialFiles, 'initialFiles')}>
                {get(inputProps, 'initialFiles', []).map((file, i) => {
                  if (get(inputProps, 'useChipsForPreview')) {
                    const renderChip = get(inputProps, 'renderChip');
                    if (renderChip) {
                      return renderChip({ key: i, file, inputProps });
                    }
                    return (
                      <Chip
                        key={i}
                        label={get(file, 'name')}
                        size="small"
                        onClick={() => {
                          window.open(file.fullUrl, '_blank');
                        }}
                        onDelete={isDisabled ? undefined : () => get(inputProps, 'onDeleteFile', noop)(file)}
                      />
                    );
                  }
                  return <Image src={file} useNaturalDims={false} key={i} alt={`image_${i}`} />;
                })}
              </div>
            )}
            {helperTextType && <FormHelperText>{helperTextType}</FormHelperText>}
          </FormControl>
        );
      } else if (isType === 'DropArea') {
        const stopProp = (e) => {
          e.stopPropagation();
          e.preventDefault();
        };

        const deleteImage = (file, index) => {
          if (inputProps.confirmDelete) {
            const confirmed = window.confirm('Are you sure you want to remove this image?');
            if (!confirmed) {
              return;
            }
          }

          const photos = get(formState, input.id, []);
          photos.splice(index, 1);
          set(
            formState,
            input.id,
            photos.map((p) => ({ ...p, hasChanged: true }))
          );
          setFormState({ ...formState });
          updateState(input.id, formState[input.id]);
        };

        const onSort = (order) => {
          order = (order || []).map((o) => ({ ...o, hasChanged: true }));
          updateState(input.id, order);
        };

        const onFilesChange = (e) => {
          if (inputProps.multiple === false) {
            updateState(
              input.id,
              [last(e)].filter((f) => !!f)
            );
          } else {
            updateState(input.id, e);
          }
        };

        const imageSelectSubmit = (e) => {
          const all = [...get(formState, input.id, []), ...e.images.map((img) => ({ ...img, hasChanged: true }))];
          onFilesChange(all);
        };

        const accept = get(inputProps, 'accept', 'image/*'); //set accept to null to use this as not an image

        const imageSelect = get(inputProps, 'imageSelect');
        const showCaption = get(inputProps, 'showCaption', true);

        if (isDisabled) {
          comp = (
            <FormControl className={clsx(classes.formControl, 'dropArea')}>
              {inputProps.label && <InputLabel className={clsx(classes.formInputLabel, classes.formLabelShrink)}>{inputProps.label}</InputLabel>}
              <ImageList images={[...get(formState, input.id, [])]} />
            </FormControl>
          );
        } else {
          comp = (
            <FormControl className={clsx(classes.formControl, 'dropArea')}>
              {inputProps.label && <InputLabel className={clsx(classes.formInputLabel, classes.formLabelShrink)}>{inputProps.label}</InputLabel>}
              <DropArea
                accept={accept || 'image/*'}
                onFilesChange={onFilesChange}
                files={[...get(formState, input.id, [])]}
                onSort={onSort}
                className={classes.dropZone}
                renderContent={() => <div style={{ padding: 8 }}>Drop Files here. Or click here.</div>}
                renderFile={(file, key) => {
                  const RenderFile = get(inputProps, '_renderFile');
                  const i = get(formState, `${input.id}`, []).findIndex((f) => f.id === file.id);
                  const valueKey = `${input.id}.${i}`;
                  if (RenderFile && i !== -1) {
                    return <RenderFile file={file} key={key} deleteImage={() => deleteImage(file, i)} valueKey={valueKey} formState={[formState, setFormState]} />;
                  }

                  const baseLoc = `${input.id}.${i}`;
                  const loc = `${baseLoc}.caption`;
                  return (
                    <div className={classes.imageWrap} onClick={stopProp}>
                      {accept && accept.indexOf('image') > -1 && <Image style={{ overflow: 'hidden' }} useNaturalDims={false} src={file.data || file.src || file.fullUrl} />}
                      {showCaption && (
                        <TextField
                          multiline
                          rows={2}
                          placeholder="caption"
                          value={get(formState, loc)}
                          onChange={(e) => {
                            set(formState, `${baseLoc}.hasChanged`, true);
                            set(formState, loc, e.target.value);
                            setFormState({ ...formState });
                            if (inputProps.shouldUpdateOnCaptionChange) {
                              updateState(input.id, formState[input.id]);
                            }
                          }}
                          className={classes.comment}
                          InputProps={{
                            className: 'no-drag',
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton className={classes.imageDelete} onClick={() => deleteImage(file, i)}>
                                  <Icon>close</Icon>
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    </div>
                  );
                }}
                {...inputProps}
              />
              {!!imageSelect && (
                <div className={'dropArea ImageSelect'}>
                  <ImageSelectBtn {...imageSelect} onSubmit={imageSelectSubmit} />
                </div>
              )}
            </FormControl>
          );
        }
      } else if (isType === 'RadioButton') {
        if (isDisabled) {
          comp = (
            <>
              <TextField
                variant={variant}
                value={get(
                  input.options.find((opt) => get(opt, 'value') === value),
                  'label',
                  value
                )}
                classes={{
                  root: classes.itemRoot,
                }}
                {...inputProps}
              />
              {helperTextType && <FormHelperText>{helperTextType}</FormHelperText>}
            </>
          );
        } else {
          comp = (
            <FormControl className={classes.toggleFormControl}>
              {inputProps.label && (
                <InputLabel shrink={false} className={classes.toggleLabel}>
                  {inputProps.label}
                </InputLabel>
              )}
              <RadioGroup
                classes={{
                  root: classes.toggleBtnRoot,
                }}
                size="small"
                value={value}
                onChange={isDisabled ? undefined : (e, val) => val && updateState(input.id, val)}
                {...inputProps}
              >
                {input.options.map((opt, i) => (
                  <FormControlLabel key={i} {...opt} control={<Radio />} />
                ))}
              </RadioGroup>
              {helperTextType && <FormHelperText>{helperTextType}</FormHelperText>}
            </FormControl>
          );
        }
      } else if (isType === 'Checkbox') {
        comp = (
          <FormControl className={classes.toggleFormControl}>
            {inputProps.label && (
              <InputLabel shrink={false} className={classes.toggleLabel}>
                {inputProps.label}
                {!!inputProps.tooltip && (
                  <Tooltip title={inputProps.tooltip.title}>
                    <Icon className={classes.infoIcon} color="primary">
                      info_circle
                    </Icon>
                  </Tooltip>
                )}
              </InputLabel>
            )}
            <FormGroup
              classes={{
                root: classes.toggleBtnRoot,
              }}
              size="small"
              {...inputProps}
            >
              {(isDisabled ? input.options.filter((o) => get(value, o.value)) : input.options).map((opt, i) => (
                <FormControlLabel
                  key={i}
                  {...opt}
                  control={
                    <Checkbox
                      onChange={isDisabled ? undefined : (e) => updateState(input.id, { ...value, [opt.value]: e.target.checked })}
                      disabled={isDisabled}
                      checked={isDisabled ? true : get(value, opt.value)}
                    />
                  }
                />
              ))}
            </FormGroup>
            {helperTextType && <FormHelperText>{helperTextType}</FormHelperText>}
          </FormControl>
        );
      } else if (isType === 'ColorSquare') {
        const color = `#${value}`;
        const isValid = isValidHex(color);
        const showColorPicker = !!get(subState, input.id);
        const onColorChange = (c, e) => {
          e.stopPropagation();
          e.preventDefault();
          updateState(input.id, c.hex.replace('#', ''));
        };
        const toggleColorPicker = () => {
          if (isDisabled) {
            return;
          }
          setSubState({ ...subState, [input.id]: !showColorPicker });
        };
        comp = (
          <TextField
            onClick={!showColorPicker && toggleColorPicker}
            variant={variant}
            error={!isValid}
            helperText={!isValid && `Invalid hex color`}
            onChange={(e) => updateState(input.id, e.target.value)}
            value={value}
            InputProps={{
              startAdornment: <InputAdornment position="start">#</InputAdornment>,
              endAdornment: (
                <InputAdornment position="end">
                  <div onClick={toggleColorPicker} className={classes.squareColor} style={{ backgroundColor: `#${value}` }} />
                  {showColorPicker && <div className={classes.colorPickerOverlay} onClick={toggleColorPicker} />}
                  {showColorPicker && (
                    <div className={classes.colorPicker}>
                      <ChromePicker color={color} disableAlpha={true} onChangeComplete={onColorChange} />
                    </div>
                  )}
                </InputAdornment>
              ),
            }}
            classes={{
              root: classes.itemRoot,
            }}
            {...inputProps}
          />
        );
      } else if (isType === 'ColorSlider') {
        const onColorChange = (e, v) => {
          if (isDisabled) {
            return;
          }
          e.stopPropagation();
          e.preventDefault();
          updateState(input.id, v);
        };
        comp = (
          <FormControl className={classes.toggleFormControl}>
            {inputProps.label && (
              <InputLabel shrink={false} className={classes.toggleLabel}>
                {inputProps.label}
              </InputLabel>
            )}
            <div className={classes.colorSliderWrap}>
              <ColorSlider {...inputProps} disabled={false} value={value} onChange={onColorChange} />
            </div>
          </FormControl>
        );
      } else if (isType === 'ChipAdd') {
        const fieldSubmit = () => {
          const fieldVal = get(subState, input.id);
          if (!fieldVal) {
            return;
          }
          updateState(input.id, [...value, fieldVal]);
          setSubState({ ...subState, [input.id]: '' });
        };
        comp = (
          <FormControl className={clsx(classes.toggleFormControl, inputProps.className)}>
            {inputProps.label && <InputLabel className={classes.toggleLabel}>{inputProps.label}</InputLabel>}
            <div className={classes.chipAddChipContainer}>
              {size(value) === 0 && isDisabled && <Typography>None</Typography>}
              {(value || []).map((v, i) => {
                return (
                  <Chip
                    size="small"
                    key={i}
                    label={v}
                    onDelete={
                      isDisabled
                        ? undefined
                        : () => {
                            value.splice(i, 1);
                            updateState(input.id, value);
                          }
                    }
                    {...get(input, 'chipProps', {})}
                  />
                );
              })}
            </div>
            {!isDisabled && (
              <div className={classes.chipAddInputContainer}>
                <TextField
                  variant={variant}
                  size="small"
                  onChange={(e) => setSubState({ ...subState, [input.id]: e.target.value })}
                  value={get(subState, input.id)}
                  onKeyDown={(e) => {
                    if (e.keyCode == 13) {
                      fieldSubmit();
                    }
                  }}
                  InputProps={{
                    placeholder: get(inputProps, 'placeholder'),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton size="small" onClick={fieldSubmit} className={classes.chipAddBtn}>
                          <Icon>add_circle</Icon>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  classes={{
                    root: classes.itemRoot,
                  }}
                />
              </div>
            )}
          </FormControl>
        );
      } else if (isType === 'JsonBuilder') {
        const updateFieldValue = (i, key, val) => {
          set(value, `${i}.${key}`, val);
          updateState(input.id, value);
        };

        const { options } = input;

        const color = 'secondary';

        const renderValueField = (v, i) => {
          const selproperty = get(v, 'property', '');
          const currentOpts = get(
            options.find((o) => o.id === selproperty),
            'props',
            get(input, 'defaultProps', {})
          );

          const val = get(value, [i, 'value']);

          const valueIsValid = (() => {
            let valid = val !== undefined && val !== '';
            const type = get(currentOpts, 'type', 'string');

            if (currentOpts.isValid) {
              valid = currentOpts.isValid(val);
            } else {
              if (type === 'duration') {
                const regex = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/gm;
                const matches = (val || '').match(regex);
                valid = !!size(matches);
              }

              if (type === 'number') {
                valid = !isNaN(parseInt(val));
              }

              if (type === 'string' && currentOpts.blankAllowed) {
                valid = true;
              }
            }

            return valid;
          })();

          const valObj = get(value, i);
          if (get(valObj, 'valid') !== valueIsValid) {
            updateFieldValue(i, 'valid', valueIsValid);
          }

          const onChange = (e) => {
            updateFieldValue(i, 'value', e.target.value);
            updateFieldValue(i, 'isDirty', true);
          };

          const helperText = !valueIsValid ? currentOpts.invalidText || 'Invalid format' : undefined;

          const standard = {
            ...currentOpts,
            variant: 'outlined',
            error: !valueIsValid,
            helperText,
            color,
            onChange,
            fullWidth: true,
            value: val,
          };

          if (!currentOpts.type || currentOpts.type === 'number') {
            return (
              <Column className="jbuilderCol">
                <TextField {...standard} />
              </Column>
            );
          } else if (currentOpts.type === 'Select') {
            return (
              <Column className="jbuilderCol">
                <Select {...standard}>
                  {currentOpts.options.map((o) => (
                    <MenuItem value={o.value}>{o.label}</MenuItem>
                  ))}
                </Select>
                {!!standard.error && <FormHelperText className="jbuilderErrorText">{standard.helperText}</FormHelperText>}
              </Column>
            );
          } else if (currentOpts.type === 'bool') {
            return (
              <Column className="jbuilderCol">
                <Select {...standard}>
                  <MenuItem value={false}>False</MenuItem>
                  <MenuItem value={true}>True</MenuItem>
                </Select>
                {!!standard.error && <FormHelperText className="jbuilderErrorText">{standard.helperText}</FormHelperText>}
              </Column>
            );
          }

          return (
            <Column className="jbuilderCol">
              <TextField {...standard} />
            </Column>
          );
        };

        comp = (
          <FormControl className={clsx(classes.toggleFormControl, inputProps.className)}>
            {inputProps.label && (
              <InputLabel shrink={false} className={classes.toggleLabel}>
                {inputProps.label}
                {!!inputProps.tooltip && (
                  <Tooltip title={inputProps.tooltip.title}>
                    <Icon className={classes.infoIcon} color="primary">
                      info_circle
                    </Icon>
                  </Tooltip>
                )}
              </InputLabel>
            )}
            {(value || []).map((val, i) => {
              const optProps = options.find((o) => o.id == val.property);

              return !get(optProps, 'show', true) ? null : (
                <ButtonGroup className="jbuilderGroup" style={{ marginBottom: 24, marginTop: 4, height: 56 }} key={val.property}>
                  {!!get(optProps, 'canDelete', true) && (
                    <MButton
                      onClick={() => {
                        value.splice(i, 1);
                        updateState(input, value);
                      }}
                    >
                      <Icon>close</Icon>
                    </MButton>
                  )}
                  <Select color={color} style={{ flex: 1 }} placeholder="Select Option" value={val.property} fullWidth onChange={(e) => updateFieldValue(i, 'property', e.target.value)}>
                    {options.map((opt, ii) => {
                      const hasKey = !!value.find((v) => v.property == opt.id);
                      return (
                        <MenuItem disabled={hasKey} key={opt.id} value={opt.id}>
                          {opt.label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {renderValueField(val, i)}
                </ButtonGroup>
              );
            })}
            <Button {...get(input, 'addBtn', {})} style={{ marginTop: 4 }} onClick={() => updateState(input.id, [...(value || []), {}])} startIcon={<Icon>edit</Icon>}>
              {get(input, 'addBtn.title', 'ADD MORE')}
            </Button>
          </FormControl>
        );
      } else {
        console.error('COMPONENT TYPE NOT SETUP!!');
      }
    } else if (input.component) {
      if (inputProps.label) {
        comp = (
          <FormControl className={classes.toggleFormControl}>
            {inputProps.label && <InputLabel className={classes.toggleLabel}>{inputProps.label}</InputLabel>}
            {input.component}
          </FormControl>
        );
      } else {
        comp = typeof input.component === 'function' ? input.component() : input.component;
      }
    }

    const style = get(input, 'style', {});

    //return render
    const canAdd = typeof input.add === 'function' ? input.add(formState, input) : input.add;
    const canRemove = typeof input.remove === 'function' ? input.remove(formState, input) : input.remove;
    let buttonRow = null;

    if (canRemove || canAdd) {
      buttonRow = (
        <div className={classes.row} style={{ justifyContent: 'flex-start' }}>
          {canAdd && (
            <Button className={classes.addBtn} variant="contained" onClick={() => addAnotherInput(input, index)} startIcon={<Icon>add</Icon>}>
              <Typography>{get(input, 'addBtn.title', 'Add')}</Typography>
            </Button>
          )}

          {canRemove && (
            <Button className={clsx(classes.addBtn, classes.removeBtn)} variant="contained" onClick={() => removeInput(input, index)} startIcon={<Icon>delete_forever</Icon>}>
              {!!get(input, 'deleteBtn.title') && <Typography>{get(input, 'deleteBtn.title')}</Typography>}
            </Button>
          )}
        </div>
      );
    }

    return (
      <div key={input.id} className={clsx(classes.inputEach, input.inputStyle, 'inputEach', isDisabled && classes.inputDisabled, isLast && isDisabled && classes.inputDisabledLast)} style={style}>
        {comp}
        {buttonRow}
      </div>
    );
  };

  const submit = async () => {
    const allowed = canContinue(true);
    if (allowed.passes) {
      onSubmit && (await onSubmit(formState));
    } else {
      const failedtitles = allowed.failed.map((f) => get(f, 'props.label', f.id)).join('\n');
      alert(`Please fix required fields: \n${failedtitles}`);
    }
  };

  const canContinue = (isSubmit = false) => {
    if (!isSubmit && screenIndex === screens.length - 1) {
      return { passes: false, failed: [] };
    }

    const screenInputs = get(screens, [screenIndex, 'inputs'], []);
    let failed = [];
    let passes = true;
    for (let i = 0; i < screenInputs.length; i++) {
      const input = screenInputs[i];
      const inputVal = get(formState, input.id);
      const isRequired = input.required || get(input, 'props.required');
      if (isRequired && (inputVal === undefined || inputVal === null || inputVal === '' || (isObject(inputVal) && _size(inputVal) === 0))) {
        passes = false;
        failed.push(input);
      }
    }
    return { passes, failed };
  };

  const renderScreen = (screen, sIndex = 0) => {
    const title = get(screen, 'title');
    const description = get(screen, 'description');

    const titleStyle = get(screen, 'titleStyle');

    const collapsable = get(screen, 'collapsable');
    const colp = get(collapsed, sIndex);

    const CONT = get(screen, 'screenContainer.component', 'div');
    const CONT_PROPS = get(screen, 'screenContainer.props', {});

    const screenContainerStyle = get(screen, 'screenContainerStyle');

    const isFullScreenForm = get(screen, 'fullScreenView', false);

    const onSort = (order, event) => {
      screen.onSort && screen.onSort(order, event);
    };

    return (
      <CONT key={sIndex} {...CONT_PROPS} className={clsx(isFullScreenForm ? classes.screenSubContainerDialog : classes.screenSubContainer, get(CONT_PROPS, 'className', 'screenSubContainer'))}>
        {title && (
          <div className={clsx('titleContainer', classes.titleContainer)}>
            <div className={classes.titleRow}>
              <Typography variant={'h4'} className={clsx(classes.title, titleStyle)}>
                {title}
              </Typography>

              {collapsable && (
                <Button
                  className={classes.collapseButton}
                  size="small"
                  variant="default"
                  color="secondary"
                  endIcon={<Icon>{colp ? 'arrow_drop_down' : 'arrow_drop_up'}</Icon>}
                  onClick={() =>
                    setCollapsed({
                      ...set(collapsed, sIndex, !colp),
                    })
                  }
                  title={colp ? 'Show' : 'hide'}
                />
              )}
            </div>
            {description && <Typography variant="inherit">{description}</Typography>}
          </div>
        )}

        {screen && (
          <div className={clsx(classes.screenContainer, screenContainerStyle, colp && classes.collapsedScreen)}>
            {screen.sortable ? (
              <DragSortableList
                items={screen.inputs.map((input, index) => ({ content: getInputType(screen, input, index, sIndex), key: input.id }))}
                dropBackTransitionDuration={0.3}
                onSort={onSort}
                placeholder={<div className={`placeholderContent`}>DROP HERE</div>}
                type={'vertical'}
              />
            ) : (
              screen.inputs.map((input, index) => {
                return getInputType(screen, input, index, sIndex);
              })
            )}
          </div>
        )}
      </CONT>
    );
  };

  useImperativeHandle(
    ref,
    () => {
      return {
        updateState,
        clearState,
        formState,
      };
    },
    []
  );

  return (
    <div style={{ height: '100%' }} ref={formref}>
      {loading ? (
        <div className={classes.formContainer}>
          <Box className={classes.centerColumn} style={{ padding: 20, margin: 'auto' }}>
            <Typography variant={'h4'}>{get(props, 'loadingMessage', 'Please Wait...')}</Typography>
            <LoadingTools fontSize="large" color="primary" style={{ marginTop: 10, fontSize: '6rem' }} />
          </Box>
        </div>
      ) : (
        <div className={clsx(classes.formScrollContainer, 'formScrollContainer')}>
          <div className={isNoMarginContainer ? clsx(classes.formContainerNoMargin, get(props, 'formStyle')) : clsx(classes.formContainer, get(props, 'formStyle'))}>
            {showAllScreens
              ? screens.map((screen, i) => {
                  if (Array.isArray(screen)) {
                    return (
                      <div key={i} className={clsx(classes.screenWrapper, 'screenWrapper')}>
                        {screen.map((scr, _i) => renderScreen(scr, `${i}.${_i}`))}
                      </div>
                    );
                  }
                  return <div className={clsx(classes.screenWrapper, 'screenWrapper')}>{renderScreen(screen, i)}</div>;
                })
              : renderScreen(screens[screenIndex], screenIndex)}
          </div>
        </div>
      )}

      {!loading && (showPosition || showNavigation || canSubmit) && (
        <Toolbar position="fixed" style={{ flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center' }}>
          <Box>
            {showPosition && (
              <div className={classes.positionContainer}>
                {screens.map((screen, i) => {
                  const num = i + 1;
                  const posTitle = get(screen, 'positionTitle', get(screen, 'title', ''));
                  const isActive = i <= screenIndex;
                  const showBar = screens.length > 1 && num < screens.length;
                  const barActive = i < screenIndex;
                  return (
                    <Fragment key={i}>
                      <div className={classes.positionWrap}>
                        <div className={clsx(classes.posNumber, isActive && classes.backgroundPrimary)}>{num}</div>
                        <div className={clsx(classes.posTitle, isActive && classes.colorPrimary)}>{posTitle}</div>
                      </div>
                      {showBar && <div className={clsx(classes.bar, barActive && classes.colorPrimary)} />}
                    </Fragment>
                  );
                })}
              </div>
            )}

            {showNavigation && (
              <div className={classes.buttonsContainer}>
                <Button color="primary" variant="outlined" disabled={screenIndex === 0} className={classes.button} onClick={() => setScreenIndex(screenIndex - 1)}>
                  BACK
                </Button>
                <Button color="primary" variant="contained" disabled={!canContinue().passes} className={classes.button} onClick={() => setScreenIndex(screenIndex + 1)}>
                  NEXT
                </Button>
                <Button color="primary" variant="contained" disabled={screenIndex !== screens.length - 1 || !canContinue(true).passes} className={classes.buttonFinish} onClick={submit}>
                  FINISH
                </Button>
              </div>
            )}
          </Box>
          <Box style={{ position: 'fixed', bottom: '8px', zIndex: 100, ...(props.submitBtnBoxStyle || {}) }}>
            {canSubmit && (
              <div className={classes.buttonsContainer}>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={props.useCheckContinue ? !canContinue(true).passes : false}
                  className={classes.buttonFinish}
                  startIcon={get(props, 'submitIcon')}
                  onClick={submit}
                >
                  {get(props, 'submitText', 'SUBMIT')}
                </Button>
              </div>
            )}
          </Box>
        </Toolbar>
      )}
    </div>
  );
});
